module.exports = __webpack_public_path__ + "/static/assets/6e61fa7e48326bd2026d28e7a62884b1.svg";